import { parsePhoneNumber } from 'react-phone-number-input';
import conObj from './connection-assistant';
import uuidv4 from './uuidv4';


const getOtpFingerprint = () => {
  let fingerprint = localStorage.getItem('fingerprint');

  if (!fingerprint) {
    fingerprint = uuidv4();
    localStorage.setItem('fingerprint', fingerprint);
  }

  return fingerprint;
};


export const toNationalDigits = (phoneNumber) => {
  if (!phoneNumber) return '';

  try {
    const parsed = parsePhoneNumber(phoneNumber);
    if (parsed) return parsed.formatNational().replace(/[^0-9]/g, '');
  } catch (error) {
    // Unparseable input — fall back to the raw digits below.
  }

  return String(phoneNumber).replace(/[^0-9]/g, '');
};

export const requestOtp = async (phoneNumber, purpose = 'register') => {
  const response = await conObj.post('otp_request.json', {
    no_hp: toNationalDigits(phoneNumber),
    fingerprint: getOtpFingerprint(),
    purpose,
  });

  return response.data?.data?.data?.otp_uuid;
};
